import { useEffect, useState } from "react";
import ConfirmModal from "components/ui/ConfirmModal";
import { FORCE_LOGOUT_NOTICE_EVENT, takeLogoutNotice } from "common/forceLogout";

/**
 * ★ 2026-10-30 강제 로그아웃 안내(전역) — 다른 기기 로그인·계정 정지·탈퇴.
 *  common/forceLogout 이 남긴 안내를 화면이 열릴 때(로그인 화면으로 새로 연 직후) 또는 이벤트로 한 번 보여 준다.
 */
const TITLES = {
  SESSION_REPLACED: "다른 기기에서 로그인했어요",
  ACCOUNT_SUSPENDED: "계정 이용이 정지됐어요",
  ACCOUNT_WITHDRAWN: "탈퇴한 계정이에요",
};

export default function ForceLogoutHost() {
  const [notice, setNotice] = useState(null);
  useEffect(() => {
    const show = () => {
      const n = takeLogoutNotice();
      if (n) setNotice(n);
    };
    show();
    window.addEventListener(FORCE_LOGOUT_NOTICE_EVENT, show);
    return () => window.removeEventListener(FORCE_LOGOUT_NOTICE_EVENT, show);
  }, []);
  return (
    <ConfirmModal
      isShow={!!notice}
      title={TITLES[notice?.code] || "로그아웃됐어요"}
      body={notice?.message || "다시 로그인해 주세요."}
      cancelText={null}
      confirmText="확인"
      onConfirm={() => setNotice(null)}
    />
  );
}
